<template>
  <layout-main-inner title="理货出库">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="title">
        <el-tooltip placement="top">
          <div slot="content">
            <p>1.选择仓库；</p>
            <p>2.选择发货单；</p>
            <p>3.创建理货单。</p>
          </div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="selectWarehouse">新建理货单</el-button>
        </el-tooltip>
      </template>
      <template slot="form">
        <!-- <el-select
          v-model="config.status"
          placeholder="请选择状态"
          @change="fetchList">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>-->
        <ent-warehouse-auto-select
          v-model="config.warehouseNo"
          :callback="() => {handleCurrentChange(1)}" />
        <el-input
          v-model="config.code"
          placeholder="请输入理货单号"
          style="width: 200px;margin-left: 10px;">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="理货单号"
          min-width="140"
          fixed="left"
          :resizable="false"
          prop="code">
          <template slot-scope="{row}">
            <!-- <link-route :link-to="`/tally-order-detail?id=${row.id}&code=${row.code}`"> -->
            {{ row.code }}
            <!-- </link-route> -->
          </template>
        </el-table-column>
        <el-table-column
          label="仓库"
          width="160"
          :resizable="false"
          prop="warehouseNo">
          <template slot-scope="{row}">
            {{ row.warehouseNo | warehouseName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="打印状态"
          width="80"
          :resizable="false"
          prop="printStatus">
          <template slot-scope="{row}">
            <!-- {{ row.printStatus === 1 ? '已打印' : '未打印' }} -->
            <el-tag
              v-if="row.printStatus === 1"
              type="success">已打印</el-tag>
            <el-tag
              v-if="row.printStatus === 0"
              type="info">未打印</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="数量信息">
          <el-table-column
            label="总货量"
            width="120">
            <template slot-scope="{row}">
              {{ row.outStockGoodsCountInfo }}
            </template>
          </el-table-column>
          <el-table-column
            label="订单数"
            prop="salesOrderCount"
            width="70">
            <template slot-scope="{row}">
              {{ row.salesOrderCount }}
            </template>
          </el-table-column>
          <el-table-column
            prop="outstockCount"
            label="发货单数"
            width="70">
            <template slot-scope="{row}">
              {{ row.outstockCount }}
            </template>
          </el-table-column>
          <el-table-column
            prop="outOrderDeliveryedCount"
            label="已发货数"
            width="70">
            <template slot-scope="{row}">
              {{ row.outOrderDeliveryedCount }}
            </template>
          </el-table-column>
          <el-table-column
            prop="outOrderPrintSuccessCount"
            label="打印成功"
            width="70">
            <template slot-scope="{row}">
              {{ row.outOrderPrintSuccessCount }}
            </template>
          </el-table-column>
          <el-table-column
            prop="outOrderPrintFailCount"
            label="打印失败"
            width="70">
            <template slot-scope="{row}">
              <span :style="{ color: row.outOrderPrintFailCount > 0 ? 'red' : null }">{{ row.outOrderPrintFailCount }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="备注"
          min-width="120">
          <template slot-scope="{row}">
            {{ row.remark }}
          </template>
        </el-table-column>
        <el-table-column
          label="创单人"
          :resizable="false"
          width="100">
          <template slot-scope="{row}">
            {{ row.createName }}
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          :resizable="false"
          width="140">
          <template slot-scope="{row}">
            {{ row.createTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="95">
          <template slot-scope="{row}">
            <el-dropdown>
              <el-button type="warning">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  @click.native="printtally(row)">明细/打印</el-dropdown-item>
                <el-dropdown-item
                  @click.native="printHtml(row)">打印面单</el-dropdown-item>
                <el-dropdown-item
                  @click.native="downloadoutorders(row)">导出明细</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
    <!-- <detail-modal ref="detail" /> -->
    <print-modal
      ref="print"
      :callback="fetchList" />
    <order-select-modal
      ref="order"
      :callback="fetchList" />
    <warehouse-select-modal
      ref="warehouse"
      :autoClose="false"
      :callback="warehouseCallback" />
    <out-select-modal ref="out" />
  </layout-main-inner>
</template>

<script>
// import SubOrderModal from './busi/sub-order-modal.vue'
// import NotagReturenModal from './busi/notag-returen-modal.vue'
// import clonedeep from 'lodash.clonedeep'
import { mapState } from 'vuex'
import WarehouseSelectModal from '../orders/busi/warehouse-select-modal.vue'
import EntWarehouseAutoSelect from '../../components/business/ent-warehouse-auto-select.vue'
// import DetailModal from './busi/detail-modal.vue'
import OrderSelectModal from './busi/order-select-modal.vue'
// import { printTemplate } from '../outstock/printTemplate.js'
import PrintModal from './busi/print-modal.vue'
import OutSelectModal from './out-select-modal.vue'

export default {
  name: 'TallyOrderList',
  components: { OrderSelectModal, WarehouseSelectModal, PrintModal, OutSelectModal, EntWarehouseAutoSelect },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        warehouseNo: null,
        code: ''
        // orderNumber: '',
        // isOriginalOrder: 1,
        // vendorId: null,
        // status: null
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      query: state => state.common.query
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    downloadoutorders(row) {
      this.loading = true
      this.$store.dispatch('outstock/downloadoutorders', {
        payload: {
          tallyOrderCode: row.code
        },
        success: () => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    expressprint(row) {
      this.$confirm('是否下单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('outstock/expressprint', {
            payload: {
              printFlag: 2,
              orderIdList: [row.id]
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    printHtml(row) {
      this.$refs.out.fetch(row)
    },
    selectWarehouse() {
      this.$refs.warehouse.fetch({
        productType: 1,
        useType: 1
      })
    },
    warehouseCallback(row) {
      this.createOutstock(row.warehouseNo)
    },
    createOutstock(warehouseNo) {
      this.$refs.order.fetch(warehouseNo)
    },
    // outdetail(row) {
    //   this.$refs.detail.fetch(row)
    // },
    printtally(row) {
      this.$refs.print.fetch(row)
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('outstock/tallyorderlist', {
        payload: {
          ...this.config
          // status: this.config.status !== null ? [this.config.status] : null
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.data.total
          this.list = res.data.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus">
 .el-table .warning-row-cus {
    background: oldlace;
  }
  .el-table .success-row-cus {
    background: rgb(240, 249, 235);
  }
</style>
